var exports = {
  "a": "Box__u7DJLb",
  "m": "Octicon__V6N1Eh",
};

module.exports = exports;
